import { Language, Characteristic, SurveyReportType, SurveyVersion, SecondaryReport } from '../models';
import { HasId } from '../interfaces';

export class CharacteristicGroupSubGroupText implements HasId {
    public id: number;
    public value: string;
    public languageId: number;
    public language: Language;
    public showModal: boolean;
}

export class CharacteristicGroupSubGroupCharacteristic implements HasId {
    public id: number;
    public characteristicGroupSubGroupID: number;
    public characteristicGroupSubGroup: CharacteristicGroupSubGroup;
    public characteristic: Characteristic | undefined;
    public characteristicID: number;
    public sort: number;
}

export class CharacteristicGroupSubGroup implements HasId {
    public id: number;
    public characteristicGroupID: number;
    public name: string;
    public sort: number;
    public characteristicGroupSubGroupCharacteristics: CharacteristicGroupSubGroupCharacteristic[];
    public characteristicGroupSubGroupTexts: CharacteristicGroupSubGroupText[];
}

export class CharacteristicGroupText implements HasId {
    public id: number;
    public textType: string;
    public value: string;
    public languageId: number;
    public language: Language;
    public showModal: boolean;
}

export class CharacteristicGroupCharacteristic implements HasId {
    public id: number;
    public characteristicID: number;
    public characteristic: Characteristic | undefined;
    public characteristicGroupID: number;
    public characteristicGroup: CharacteristicGroup | undefined;
    public sort: number;
}

export class CharacteristicCompareText implements HasId {
    public id: number;
    public textType: string;
    public value: string;
    public languageId: number;
    public language: Language;
    public showModal: boolean;
}

export class CharacteristicCompare implements HasId {
    public id: number;
    public characteristicLeftID: number;
    public characteristicLeft: Characteristic;
    public characteristicRightID: number;
    public characteristicRight: Characteristic;
    public characteristicCompareTexts: CharacteristicCompareText[];
    public surveyReportTypeID: number;
    public name: string;
    public sort: number;
    public characteristicCompareScoreType: string;
    public characteristicCompareScoreSide: string;
    public threshold: number;
    public useInteractionReport: boolean;
}

export class CharacteristicGroup implements HasId {
    public id: number;
    public name: string;
    public subtitle: string;
    public surveyVersionID: number;
    public surveyVersion: SurveyVersion;
    public characteristicGroupTexts: CharacteristicGroupText[];
    public characteristics: Characteristic[];
    public sort: number;
    public surveyReportTypeID: number;
    public surveyReportType: SurveyReportType;
    public characteristicGroupCharacteristics: CharacteristicGroupCharacteristic[];
    public secondaryReportID?: number;
    public secondaryReport: SecondaryReport;
    public characteristicCompares: CharacteristicCompare[];
    public characteristicGroupDisplayType: string;
    public characteristicGroupSubGroups: CharacteristicGroupSubGroup[];
}


// WEBPACK FOOTER //
// ./src/models/CharacteristicGroup.tsx